import { useEffect, useState } from "react";
import { ArrowUpRight, X } from "lucide-react";
import { commercialConfig } from "@/config/commercialConfig";

const flyerPath = "/assets/cittiglio-flyer.webp";

export default function CittiglioBanner() {
  const [isFlyerOpen, setIsFlyerOpen] = useState(false);

  useEffect(() => {
    if (!isFlyerOpen) return undefined;
    const closeOnEscape = (event) => {
      if (event.key === "Escape") setIsFlyerOpen(false);
    };
    document.addEventListener("keydown", closeOnEscape);
    return () => document.removeEventListener("keydown", closeOnEscape);
  }, [isFlyerOpen]);

  return (
    <>
      <section className="cittiglio-banner" data-testid="cittiglio-promo-banner">
        <button className="cittiglio-banner-visual" type="button" onClick={() => setIsFlyerOpen(true)} aria-label="Apri il volantino completo del deposito Cittiglio" data-testid="cittiglio-flyer-open-image-button">
          <img src={flyerPath} alt="Anteprima volantino Cittiglio - Travertino Romano da Tivoli" data-testid="cittiglio-flyer-open-image" />
          <span className="cittiglio-banner-visual-label">Apri volantino <ArrowUpRight size={15} /></span>
        </button>
        <div className="cittiglio-banner-copy">
          <div className="cittiglio-banner-kicker"><span>PRONTA CONSEGNA</span><span>CITTIGLIO / VA</span></div>
          <h2>Travertino Romano<br /><i>pronto al ritiro.</i></h2>
          <p>Piastrelle da Tivoli in diversi formati e spessori, direttamente dal deposito di Via per Mombello 15.</p>
          <div className="cittiglio-price-grid"><div><strong>€ 42</strong><span>/m² · spessore 2 cm</span></div><div><strong>€ 52</strong><span>/m² · spessore 3 cm</span></div></div>
          <div className="cittiglio-banner-actions"><button className="button button-light" type="button" onClick={() => setIsFlyerOpen(true)} data-testid="cittiglio-flyer-open">Vedi tutti i formati <ArrowUpRight size={16} /></button><a href={`mailto:${commercialConfig.checkout.supportEmail}`} data-testid="cittiglio-flyer-contact">Richiedi disponibilità <ArrowUpRight size={16} /></a></div>
        </div>
      </section>
      {isFlyerOpen && <div className="flyer-modal-backdrop" role="presentation" onClick={() => setIsFlyerOpen(false)}><div className="flyer-modal" role="dialog" aria-modal="true" aria-labelledby="flyer-modal-title" data-testid="cittiglio-flyer-modal" onClick={(event) => event.stopPropagation()}><div className="flyer-modal-head"><div><span className="eyebrow">StoneInLove / pronta consegna</span><h2 id="flyer-modal-title">Deposito Cittiglio.</h2></div><button className="modal-close" type="button" onClick={() => setIsFlyerOpen(false)} aria-label="Chiudi volantino" data-testid="cittiglio-flyer-close"><X size={20} /></button></div><div className="flyer-modal-image-wrap"><img src={flyerPath} alt="Volantino completo Travertino Romano da Tivoli, deposito Cittiglio" /></div><p className="flyer-modal-note">Prezzi speciali indicati nel banner per le marmette disponibili al ritiro.</p></div></div>}
    </>
  );
}
